import { useState } from "react";
import { updateRoute } from "../../services";
import { RouteManagementRow } from "../../types/route.type";
import ConfirmModal from "../ConfirmModal";
import { QR_PAYMENT_OFF_TEXT, QR_PAYMENT_ON_TEXT } from "./routeText";

interface QrPaymentDialogProps {
  /** The route whose QR payment is being switched; null keeps the dialog closed. */
  target: RouteManagementRow | null;
  onClose: () => void;
  onSaved: () => void;
}

export default function QrPaymentDialog({
  target,
  onClose,
  onSaved,
}: QrPaymentDialogProps) {
  const [saving, setSaving] = useState<boolean>(false);

  const isTurningOn = !target?.qr_payment_enabled;
  const text = isTurningOn ? QR_PAYMENT_ON_TEXT : QR_PAYMENT_OFF_TEXT;
  const title = `${text.title} สาย ${target?.route_code ?? ""}`;

  /** Answers whether the API stored the new switch. */
  const saveSwitch = async (route: RouteManagementRow): Promise<boolean> => {
    try {
      await updateRoute(
        route.uuid,
        { qr_payment_enabled: !route.qr_payment_enabled },
        text.successMsg,
      );
      return true;
    } catch {
      // The interceptor already showed the API's own message (422 when the route is not live
      // yet, 403 for a role without the right); the route keeps its switch.
      return false;
    }
  };

  const handleConfirm = async () => {
    if (!target) return;
    setSaving(true);
    const saved = await saveSwitch(target);
    setSaving(false);
    if (saved) onSaved();
    onClose();
  };

  const handleClose = () => {
    if (saving) return;
    onClose();
  };

  return (
    <ConfirmModal
      open={Boolean(target)}
      title={title}
      description={text.description}
      confirmLabel={text.confirmLabel}
      loading={saving}
      onClose={handleClose}
      onConfirm={handleConfirm}
    />
  );
}
